module.exports = __webpack_public_path__ + "static/img/4.8343ac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/4.png
// module id = LWG0
// module chunks = 0